/*
 * Testi di partenza delle assemblee (TASK #11, 21/10/2026), dal documento «Sportid - lavorazioni II blocco»:
 * «Testo di default da far comparire nel testo della convocazione» e «… nelle note del verbale», più la delega.
 *
 * Compaiono in una convocazione nuova e in un verbale mai salvato: la struttura li modifica come vuole, e
 * un modello di convocazione scelto li sostituisce. Le righe «______» sono da completare a mano.
 *
 * L'ordine del giorno del documento diventa la lista dei punti (non testo libero), perché ogni punto ha il
 * suo esito nel verbale; i punti che si votano hanno «Richiede votazione» acceso.
 */

export const ORDINE_DEL_GIORNO_PREDEFINITO = [
	{ title: 'Lettura e approvazione del verbale della seduta precedente', description: '', requiresVote: true },
	{ title: "Approvazione del rendiconto economico-finanziario dell'esercizio ______", description: '', requiresVote: true },
	{ title: 'Relazione del Presidente sulle attività associative', description: '', requiresVote: false },
	{ title: "Programmazione delle attività sportive e istituzionali per l'anno ______", description: '', requiresVote: true },
	{ title: 'Determinazione delle quote associative', description: '', requiresVote: true },
	{ title: 'Varie ed eventuali', description: '', requiresVote: false }
];

// Nel PDF e nell'email il testo viene prima dell'elenco dei punti: «Cordiali saluti» del documento non si mette,
// altrimenti chiuderebbe la lettera prima dell'ordine del giorno.
export const TESTO_CONVOCAZIONE_PREDEFINITO =
	"<p>I soci impossibilitati a partecipare potranno farsi rappresentare secondo le modalità previste dallo Statuto dell'Associazione.</p>" +
	"<p>Data l'importanza degli argomenti all'ordine del giorno, riportato qui sotto, si invita a partecipare.</p>";

export const TESTO_DELEGA_PREDEFINITO =
	'<p><strong>DELEGA (facoltativa)</strong></p>' +
	'<p>Il/La sottoscritto/a ______________________________,<br>' +
	'socio dell\'Associazione Sportiva Dilettantistica ______________________________,<br>' +
	'delega il/la socio/a ______________________________<br>' +
	"a rappresentarlo/a nell'Assemblea dei Soci convocata per il giorno ___/___/______.</p>" +
	'<p>Data ___/___/______</p>' +
	'<p>Firma del Delegante ______________________________</p>' +
	'<p>Firma del Delegato (per accettazione) ______________________________</p>';

export const NOTE_VERBALE_PREDEFINITE =
	'<p><strong>Allegati (eventuali)</strong></p>' +
	'<ul>' +
	'<li>Elenco soci presenti.</li>' +
	'<li>Deleghe.</li>' +
	'<li>Bilancio/Rendiconto economico-finanziario.</li>' +
	'<li>Relazione del Presidente.</li>' +
	"<li>Documentazione illustrata durante l'Assemblea.</li>" +
	'<li>Altro: ______________________________.</li>' +
	'</ul>';
